import { PresetObj } from '../types/general-types';

export const defaultPresets: PresetObj[] = [
    {
      section: 'In/Out',
      name: 'Ease',
      value: [ 0.42, 0, 0.58, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 0
    },
    {
      section: 'In/Out',
      name: 'Quad In/Out',
      value: [ 0.48, 0.04, 0.52, 0.96 ],
      type: 'bezier',
      isStandard: true,
      index: 1
    },
    {
      section: 'In/Out',
      name: 'Cubic In/Out',
      value: [ 0.66, 0, 0.34, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 2
    },
    {
      section: 'In/Out',
      name: 'Quart In/Out',
      value: [ 0.76, 0, 0.24, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 3
    },
    {
      section: 'In/Out',
      name: 'Quint In/Out',
      value: [ 0.84, 0, 0.16, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 4
    },
    {
      section: 'In/Out',
      name: 'Expo In/Out',
      value: [ 1, 0, 0, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 5
    },
    {
      section: 'In/Out',
      name: 'Circ In/Out',
      value: [ 0.88, 0.14, 0.12, 0.86 ],
      type: 'bezier',
      isStandard: true,
      index: 6
    },
    {
      section: 'In/Out',
      name: 'Quick In/Out',
      value: [ 0.4, 0.1, 0.8, 0.9 ],
      type: 'bezier',
      isStandard: true,
      index: 7
    },
    {
      section: 'In/Out',
      name: 'Quicker In/Out',
      value: [ 0.6, 0.2, 0.6, 0.8 ],
      type: 'bezier',
      isStandard: true,
      index: 8
    },
    {
      section: 'In',
      name: '0-30',
      value: [ 0, 0, 0.7, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 9
    },
    {
      section: 'In',
      name: '0-40',
      value: [ 0, 0, 0.6, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 10
    },
    {
      section: 'In',
      name: '0-60',
      value: [ 0, 0, 0.4, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 11
    },
    {
      section: 'In',
      name: '0-80',
      value: [ 0, 0, 0.2, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 12
    },
    {
      section: 'In',
      name: '0-100',
      value: [ 0, 0, 0, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 13
    },
    {
      section: 'In',
      name: 'Cubic In',
      value: [ 0.32, 0.94, 0.6, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 14
    },
    {
      section: 'In',
      name: 'Quad In',
      value: [ 0.4, 0.8, 0.74, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 15
    },
    {
      section: 'In',
      name: 'Quart In',
      value: [ 0.26, 1, 0.48, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 16
    },
    {
      section: 'In',
      name: 'Quint In',
      value: [ 0.22, 1, 0.36, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 17
    },
    {
      section: 'In',
      name: 'Expo In',
      value: [ 0.14, 1, 0.34, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 18
    },
    {
      section: 'In',
      name: 'Circ In',
      value: [ 0, 0.56, 0.46, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 19
    },
    {
      section: 'Out',
      name: '30-0',
      value: [ 0.3, 0, 1, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 20
    },
    {
      section: 'Out',
      name: '40-0',
      value: [ 0.4, 0, 1, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 21
    },
    {
      section: 'Out',
      name: '60-0',
      value: [ 0.6, 0, 1, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 22
    },
    {
      section: 'Out',
      name: '80-0',
      value: [ 0.8, 0, 1, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 23
    },
    {
      section: 'Out',
      name: '100-0',
      value: [ 1, 0, 1, 1 ],
      type: 'bezier',
      isStandard: true,
      index: 24
    },
    {
      section: 'Out',
      name: 'Cubic Out',
      value: [ 0.4, 0, 0.68, 0.06 ],
      type: 'bezier',
      isStandard: true,
      index: 25
    },
    {
      section: 'Out',
      name: 'Quad Out',
      value: [ 0.26, 0, 0.6, 0.2 ],
      type: 'bezier',
      isStandard: true,
      index: 26
    },
    {
      section: 'Out',
      name: 'Quart Out',
      value: [ 0.52, 0, 0.74, 0 ],
      type: 'bezier',
      isStandard: true,
      index: 27
    },
    {
      section: 'Out',
      name: 'Quint Out',
      value: [ 0.64, 0, 0.78, 0 ],
      type: 'bezier',
      isStandard: true,
      index: 28
    },
    {
      section: 'Out',
      name: 'Expo Out',
      value: [ 0.66, 0, 0.86, 0 ],
      type: 'bezier',
      isStandard: true,
      index: 29
    },
    {
      section: 'Out',
      name: 'Circ Out',
      value: [ 0.54, 0, 1, 0.44 ],
      type: 'bezier',
      isStandard: true,
      index: 30
    }
  ]